"use client";
import { type ReactNode } from "react";
import { useActualViewer } from "../session/use-actual-viewer";

export function SignedInOnly({ children }: { readonly children: ReactNode }) {
  return useActualViewer().data != null ? children : null;
}
